import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Contact from '../components/Contact';

export default function Home({ scrollToSection }) {
  useEffect(() => {
    document.title = "Mette Brisson | Psykolog på Frederiksberg – Terapi & Supervision";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Psykolog Mette Brisson på Frederiksberg tilbyder individuel terapi, parterapi, NARM-terapi, supervision samt hjælp til stress, angst, efterfødselsreaktioner og livskriser. Book en tid i dag.');
    }
  }, []);

  return (
    <>
      {/* Hero Section */}
      <Hero scrollToSection={scrollToSection} />

      {/* Services Section ("Jeg hjælper dig med") */}
      <Services />

      {/* About Section ("Om mig") */}
      <About scrollToSection={scrollToSection} />

      {/* Contact Section ("Kontakt") */}
      <Contact />
    </>
  );
}
